import { DepartureOptions } from '@lt/api/dist/types/departure';
import { useField } from 'formik';
import { useEffect, useState } from 'react';
// @todo
import { useIsMounted } from 'usehooks-ts';
import { FIELD_NAMES } from '../constants';
import { Values } from '../context';
import { useGetApiClient } from '../../../context/apiContext';

export const useFetchAvailableDepartures = (options: DepartureOptions, isMobile: boolean) => {
  const [{ value: destinationValue }] = useField<Values['destination']>(FIELD_NAMES.destination);
  const [optionsWithAvailability, setOptionsWithAvailability] = useState(options);
  const isMounted = useIsMounted();
  const api = useGetApiClient();

  useEffect(() => {
    if (
      destinationValue?.groupName === 'popularCountries' ||
      destinationValue?.groupName === 'allCountries' ||
      destinationValue?.groupName === 'countries'
    ) {
      api
        ?.getReferencesDepartureCities({
          to_country: destinationValue?.nameEn,
        })
        // @todo
        .then((availableDepartures: Record<number, boolean>) => {
          if (isMounted()) {
            const updatedOptions = options.map((option) => ({
              ...option,
              isClosed: !availableDepartures[option.id],
              destinationLabel: destinationValue?.nameRuForm3,
            }));
            setOptionsWithAvailability(updatedOptions);
          }
        })
        .catch(console.error);
    } else {
      setOptionsWithAvailability(options);
    }
  }, [destinationValue, isMobile, isMounted, options]);

  return { optionsWithAvailability };
};
